import { ChangeDetectionStrategy, Component, HostBinding, input } from '@angular/core';

@Component({
    selector: 'ms-sgp-badge',
    template: ` <div class="theme-bet-builder sgp-badge"></div> `,
    styleUrl: './sgp-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SGPBadgeComponent {
    @HostBinding('class.large') get large(): boolean {
        return this.size() === 'large';
    }

    size = input<'large'>();
}
